import React, {useState} from 'react';
import {StyleSheet, View} from 'react-native';

import {AirtablePromotionItem} from '../../../models/airtable';
import {AppRoute} from '../../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../../models/navigationTypes';
import Button from '../../ui-controls/Button';

type GamePlayActionsProps = {
  activation: AirtablePromotionItem;
  // Use RouteNavigatorScreenProps directly instead of importing from screen to avoid circular dependency
  navigation: RouteNavigatorScreenProps<AppRoute.PROMOTION>['navigation'];
  gameParams?: {iFrameLinkParams?: unknown};
  isPracticePlay?: boolean;
  onNotEnterGame?: () => void;
};

const GamePlayActions = ({
  activation,
  navigation,
  gameParams,
  isPracticePlay = false,
  onNotEnterGame = () => {},
}: GamePlayActionsProps) => {
  const [hasPressedEnterGame, setHasPressedEnterGame] = useState(false);

  const {game} = activation;

  const summerCashGrabIFrameParams = gameParams?.iFrameLinkParams;

  const playText = game.playText || 'PLAY THE GAME TO WIN';
  const noPlayText = game.noPlayText || 'NO, THANKS';

  const handleEnterGame = async () => {
    setHasPressedEnterGame(true);
    navigation.navigate(AppRoute.SUMMER_CASH_GRAB_GAME, {
      url: activation.iFrameLink,
      iFrameLinkParams: summerCashGrabIFrameParams,
    });
  };

  const enterGameButtonText = playText;

  return (
    <View>
      <Button
        onPress={handleEnterGame}
        title={enterGameButtonText}
        buttonStyle={styles.enterHereButton}
      />
      {!isPracticePlay && (
        <Button
          onPress={onNotEnterGame}
          title={hasPressedEnterGame ? 'DISMISS' : noPlayText}
          buttonStyle={styles.enterHereButton}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  enterHereButton: {
    width: '80%',
    margin: 8,
  },
});

export default GamePlayActions;
